import request from '@/utils/request'

export const getDeptList = ({ page, size, deptName }) => {
  return request({
    url: `/upms/dept/${page}/${size}`,
    params: {
      deptName
    }
  })
}

export const postDeptEdit = (data) => {
  return request({
    method: 'post',
    url: '/upms/dept',
    data
  })
}

export const putDeptAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/dept',
    data
  })
}

export const getDeptDetail = (id) => {
  return request({
    url: `/upms/dept/${id}`
  })
}

export const deleteDeptDel = (id) => {
  return request({
    method: 'delete',
    url: `/upms/dept/${id}`
  })
}

export const getDeptTree = () => {
  return request({
    url: '/upms/dept/tree'
  })
}

export const delDeptList = (data) => {
  return request({
    method: 'delete',
    url: '/upms/dept/all',
    data
  })
}
